<div class="pharmacyPage cardPage">
  <div class="pharmacy_header">
    <div class="container header_container">
      <div class="comman-width">
        <h2>My Cards</h2>
      </div>
      <!-- <div class="right_btn_sec">
        <div class="map_btn mycards_width is-hidden-desktop is-hidden-mobile" style="width: 180px;">
          <i></i>
          Locate on Map
          <input type="checkbox" id="locate" (click)="Showmapview()" />
          <label for="locate">
            <i></i>
          </label>
        </div>
        <div class="sortby_mycards mycards_width is-hidden-desktop is-hidden-mobile" (click)="sortbyddl = !sortbyddl">
          Sort By
          <i></i>
        </div>
        <div class="sortby_ddl" [hidden]="!sortbyddl">
          <ul *ngIf="IsDistancesort">
            <li (click)="SortcardsList('Distance')" class="active">Distance</li>
            <li (click)="SortcardsList('Price')">Price</li>
          </ul>
          <ul *ngIf="IsPricesort">
            <li (click)="SortcardsList('Distance')">Distance</li>
            <li (click)="SortcardsList('Price')" class="active">Price</li>
          </ul>
        </div>
      </div> -->
    </div>
  </div>
  <!-- <div class="pharmacy_header bottom is-hidden-desktop">
    <div class="container header_container">
      <div class="right_btn_sec">

        <div class="pharmacy-filter-btn">
          <div class="sortby" (click)="hideSortby(); $event.stopPropagation()">
            <i></i>
            Sort By
          </div>
          <div class="sortby_ddl" [hidden]="!sortbyddl">
            <div class="dark-bg"></div>
            <h1>Sort by</h1>
            <ul *ngIf="IsDistancesort">
              <li (click)="SortPharmacyList('Distance')" class="active">Distance
              </li>
              <li (click)="SortPharmacyList('Rating')">Rating</li>
              <li (click)="SortPharmacyList('Price')">Price</li>
            </ul>
            <ul *ngIf="IsPricesort">
              <li (click)="SortPharmacyList('Distance')" class="active">
                Distance</li>
              <li (click)="SortPharmacyList('Rating')">Rating</li>
              <li (click)="SortPharmacyList('Price')">
                Price</li>
            </ul>
            <div class="sortby_btn">Done</div>
          </div>
        </div>
        <div class="pharmacy-filter-btn">
          <div class="filter-btn-mobile" (click)="filteron_mobile()">
            <i></i>
            Filters
          </div>
        </div>
      </div>
    </div>
  </div> -->
  <div class="container" id="pharmacy_container">
    <div class="pharmacy_box mycards">
      <div class="pharmacy_list mycards_Sec">
        <!-- ---------------------Sample Card-------------------------- -->
        <div class="card" (click)="SampleDiscountcard()">
          <div class="name_Sec">
            <p>Can't find your medication?</p>
            <span>$</span>
          </div>
          <div class="distance">Use this card and save now!</div>
          <div class="distance"></div>
        </div>

        <div class="card" *ngFor="let item of CardsList" (click)="showDiscountcard(item)">
          <div class="name_Sec">
            <p>{{item.DrugName}}</p>
            <span>{{item.Price}}</span>
          </div>
          <div class="distance">{{item.Quantity}} {{item.Form}} {{item.Dose}}</div>
          <div class="distance">{{item.PharmacyName}}</div>
        </div>
      </div>
      <!-- <div class="maps_box" *ngIf="mapview">mapview</div> -->
    </div>
  </div>
  <!-- Discount Card -->
  <div class="discount_card" *ngIf="showcard" id="print-section">
    <div class="close_search_pharmacy_popup is-hidden-mobile" (click)="CloseDrugDetails()"></div>
    <div class="discount_card_parent">
      <div class="close_search_pharmacy_popup is-hidden-desktop" (click)="CloseDrugDetails()"></div>
      <div class="header">
        <img src="../../assets/images/logo-white-bg.png" alt="" />
        <div class="button_sec">
          <!-- <div class="sendsms">Send SMS</div> -->
          <div class="remove" (click)="RemoveCard(Group_Number)"></div>
          <div class="print" (click)="PrintMe()" data-after="Print"></div>
        </div>
      </div>
      <div class="pharmacyDetail">
        <div class="name">
          {{ SelectPharmacy }}
        </div>
        <div class="address">{{ PAddress2 }}</div>
        <!--<a *ngIf="PharmacyPhone" class="number" [href]="'tel://' + PharmacyPhone">{{ PharmacyPhone }}</a>-->
        <div class="border-bottom"></div>
        <div class="method_salt one">
          <div class="method col-lg-6-0l">
            <div>DRUG</div>
            <div>{{ Card_DrugName }}</div>
          </div>
          <div class="method">
            <div>DOSAGE</div>
            <div>{{ Card_Dosage }}</div>
          </div>
          <div class="method">
            <div>FORM</div>
            <div>{{ Card_DrugForm }}</div>
          </div>
        </div>
        <div class="method_salt two">
          <div class="method">
            <div>bin</div>
            <div>{{ RXBin }}</div>
          </div>
          <div class="method">
            <div>PCN</div>
            <div>{{ RXCPN }}</div>

          </div>
          <div class="method">
            <div>Member ID</div>
            <div>{{ MemberId }}</div>
          </div>
          <div class="method">
            <div>Group</div>
            <div>{{ Group_Number }}</div>
          </div>
        </div>
        <p class="no-insurance pt-0">The NuLifeSpan Rx prescription discount program is free. <span class="strong-text">This is not insurance.</span></p>
        <div class="email_field" style="position: relative">
          <input type="email" id="email" name="ShareEmail" placeholder=" " [(ngModel)]="UserInputEmail"
            (click)="ClearMessage($event)" (blur)="ClearMessage($event)" (keypress)="clearClassMsg()"
            autocomplete="off" />
          <label for="email">Enter your e-mail</label>
          <div class="sendbtn" (click)="ShareDiscountCard()">Send</div>
          <div class="loadProcess"></div>
        </div>
        <span style="color:#f19f57">{{ SendDiscountMessage }}</span>
        <div class="helpline_btn">
          <div class="helpline" (click)="PharmacyHelpLine()">
            {{ PharmacistHelpline }}
          </div>
          <div class="direction" (click)="RedirectGoogleDirection()">
            Get Directions
            <img src="../../assets/images/direction.svg" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="discount_card" *ngIf="SampleDiscountCard">
    <div class="close_search_pharmacy_popup is-hidden-mobile" (click)="CloseDrugDetails()"></div>
    <div class="discount_card_parent">
      <div class="close_search_pharmacy_popup is-hidden-desktop" (click)="CloseDrugDetails()"></div>
      <div class="header">
        <img src="../../assets/images/logo-white-bg.png" alt="" />
        <div class="button_sec">
            <div class="print" (click)="PrintMe()">Print</div>
        </div>
      </div>
      <div class="pharmacyDetail">
        <div class="name">
          {{HeadingText}}
        </div>
        <div class="address">{{PAddress2}}</div>
        <div class="number">{{PharmacyPhone}}</div>
        <div class="method_salt">
          <div class="method">
            <div>bin</div>
            <div>{{RXBin}}</div>
          </div>
          <div class="method">
            <div>PCN</div>
            <div>{{RXCPN}}</div>
          </div>
          <div class="method">
            <div>Member ID</div>
            <div>{{MemberId}}</div>
          </div>
          <div class="method">
            <div>Group</div>
            <div>{{ Group_Number }}</div>
          </div>
        </div>
        <p class="no-insurance">The NuLifeSpan Rx prescription discount program is free. <span class="strong-text">This is not insurance.</span></p>
        <div class="email_field default">
            <input type="email" id="email" name="ShareEmail" placeholder=" " [(ngModel)]="UserInputEmail" (click)="ClearMessage($event)"/>
            <label for="email">Enter your e-mail</label>
            <div class="sendbtn"(click)="ShareDiscountCardGeneric()">Send</div>
            <div class="loadProcess"></div>
          </div>
        <span>{{SendDiscountMessage}}</span>
        <div class="helpline_btn">
        </div>
      </div>
    </div>
  </div>
</div>